<div class="dialog">
    <button class="dialog__close-btn" matDialogClose></button>
    <h2 class="dialog__title">Wishlist is empty</h2>
    <p class="dialog__description">
        It’s not that you don’t want thing, it’s just that you haven’t saved them here yet...
    </p>
    <div class="dialog__heart-box">
        <mat-icon [svgIcon]="ESvgIcons.HURT"></mat-icon>
    </div>
</div>
